import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';
import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/users', {
        template: require('./users.html'),
        controller: 'UsersController'
    });
})
.controller('UsersController', function($scope, $location, User) {
    canFilter($scope, $location);
    canPaginate($scope, $location);
    $scope.s || ($scope.s = 'email');
    $scope.loading = true;
    $scope.newAdminURL = NEW_ADMIN_URL;

    const params = _.pick($scope, 'q', 's', 'p');

    if ($scope.f.account && $scope.f.account.active) {
        params['filter.account_id'] = $scope.f.account.id
    }
    params['filter.include_archived'] = 'false';

    $scope.users = User.search(params, function(data, getResponseHeader) {
        $scope.loading = false;
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });
});


// WEBPACK FOOTER //
// ./views/users/users_controller.js